// InventoryAdminInventory - Sales Performance Component
import React, { useState } from 'react';
import '../../../../assests/css/admin/Analytics/SalesPerformance/SalesPerformance.css';

const SalesPerformance = () => {
  const [activeView, setActiveView] = useState('revenue');
  
  const salesData = [
    { day: 'MON', revenue: 75, orders: 45 },
    { day: 'TUE', revenue: 65, orders: 38 },
    { day: 'WED', revenue: 85, orders: 52 },
    { day: 'THU', revenue: 90, orders: 58 },
    { day: 'FRI', revenue: 78, orders: 48 },
    { day: 'SAT', revenue: 60, orders: 35 },
    { day: 'SUN', revenue: 55, orders: 32 }
  ];

  const currentData = salesData.map(d => ({
    day: d.day,
    value: activeView === 'revenue' ? d.revenue : d.orders
  }));

  const maxValue = Math.max(...currentData.map(d => d.value));

  return (
    <div className="InventoryAdminInventory-sales-performance">
      <div className="InventoryAdminInventory-sales-header">
        <div>
          <div className="InventoryAdminInventory-sales-title">Sales Performance</div>
          <div className="InventoryAdminInventory-sales-subtitle">
            Daily revenue compared to previous period
          </div>
        </div>
        <div className="InventoryAdminInventory-sales-legend">
          <button
            onClick={() => setActiveView('revenue')}
            className={`InventoryAdminInventory-legend-item ${activeView === 'revenue' ? 'active' : ''}`}
          >
            <div className="InventoryAdminInventory-legend-dot revenue"></div>
            <span>Revenue</span>
          </button>
          <button
            onClick={() => setActiveView('orders')}
            className={`InventoryAdminInventory-legend-item ${activeView === 'orders' ? 'active' : ''}`}
          >
            <div className="InventoryAdminInventory-legend-dot orders"></div>
            <span>Orders</span>
          </button>
        </div>
      </div>

      <div className="InventoryAdminInventory-chart-container">
        <div className="InventoryAdminInventory-y-axis">
          <span className="InventoryAdminInventory-y-label">$75k</span>
          <span className="InventoryAdminInventory-y-label">$50k</span>
          <span className="InventoryAdminInventory-y-label">$25k</span>
          <span className="InventoryAdminInventory-y-label">$0</span>
        </div>
        
        <div className="InventoryAdminInventory-bars-container">
          {currentData.map((data, index) => {
            const heightPercent = (data.value / maxValue) * 100;
            const isThursday = data.day === 'THU';
            
            return (
              <div 
                key={data.day} 
                className="InventoryAdminInventory-chart-bar"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="InventoryAdminInventory-bar-wrapper">
                  {/* Background bar (light gray) */}
                  <div 
                    className="InventoryAdminInventory-background-bar"
                    style={{ animationDelay: `${index * 0.1}s` }}
                  ></div>
                  
                  {/* Active bar (blue/gray) */}
                  <div 
                    className={`InventoryAdminInventory-bar ${activeView} ${isThursday ? 'highlighted' : ''}`}
                    style={{ 
                      height: `${heightPercent}%`,
                      animationDelay: `${0.3 + index * 0.1}s`
                    }}
                  >
                    {isThursday && (
                      <div className="InventoryAdminInventory-tooltip">
                        <div className="InventoryAdminInventory-tooltip-value">
                          ${data.value}k
                        </div>
                        <div className="InventoryAdminInventory-tooltip-arrow"></div>
                      </div>
                    )}
                  </div>
                </div>
                <div className={`InventoryAdminInventory-bar-label ${isThursday ? 'highlighted' : ''}`}>
                  {data.day}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SalesPerformance;